export const mainBlocks = [
  {
    name: 'mechanika',
    list: [{
      key: 'naprawa układów',
      items: [
        'paliwowych',
        'wydechowych',
        'kierowniczych',
        'hamulcowych',
        'chłodniczych',
        'napędowych',
        'naprawy zawieszenia',
        'remonty silników',
        'wymiana sprzęgła',
        'wymiana rozrzadu'
      ]
    }]
  },
  {
    name: 'diagnostyka',
    list: [
      {
        key: 'komputerowa diagnostyka systemów',
        items: [
          'kompleksowa diagnostyka silników',
          'climatronic',
          'wspomagania',
          'sterowania',
          'zasilania',
          'przekładni automatycznych',
          'usuwanie inspekcji'
        ]
      }
    ]
  },
  {
    name: 'wulkanizacja',
    list: [
      {
        key: null,
        items: [
          'wymiana opon',
          'komputerowe wyważanie opon',
          'sezonowe przechowywanie opon',
          'kompleksowa wulkanizacja opon',
          'sprzedaż opon nowych i używanych',
          'sprzedaż felg nowych i używanych',
          'dobór opon dla potrzeb klienta'
        ]
      }
    ]
  }
]

export const additionalBlocks = [
  {
    name: 'elektryka',
    list: [
      {
        key: null,
        items: [
          'naprawa defektów instalacji elektrycznej',
          'wymiana elementów elektronicznych w pojazdach'
        ]
      }
    ]
  },
  {
    name: 'Części zamienne',
    list: [
      {
        key: null,
        items: [
          'Nasi importerzy są liderami nie tylko polskiego, ale i światowego rynku części zamiennych do samochodów. Rodzaj, jakość części i ich producenci są wyselekocjonowani po latach współpracy.'
        ]
      }
    ]
  }
]
